import React, { Component } from "react";
import PropTypes from "prop-types";
import IErrorDTO from "../../../models/DTO/IErrorDTO";
import IGetCommissionTiersDTO from "../../../models/DTO/IGetCommissionTiersDTO";
import IGetRebateGroupDTO from "../../../models/DTO/IGetRebateGroupDTO";
import IGetRebateGroupsDTO from "../../../models/DTO/IGetRebateGroupsDTO";
import IOnGetCommissionTiersDTO from "../../../models/DTO/IOnGetCommissionTiersDTO";
import IOnGetRebateGroupsDTO from "../../../models/DTO/IOnGetRebateGroupsDTO";
import IBreadcrumbs from "../../../models/IBreadcrumbs";
import IRebate from "../../../models/IRebate";
import IRebate_GroupUI from "../../../models/IRebate_GroupUI";
import ISupplierModel from "../../../models/ISupplierModel";
import IUserUI from "../../../models/IUserUI";
import Breadcrumbs from "../../shared/Breadcrumbs/Breadcrumbs";
import ChevronToggle from "../../shared/ChevronToggle/ChevronToggle";
import { LoadingResults } from "../../shared/LoadingResults/LoadingResults";
import NoResults from "../../shared/NoResults/NoResults";
import OwButton from "../../shared/OwButton/OwButton";
import OwLabel from "../../shared/OwLabel/OwLabel";
import OwTitle from "../../shared/OwTitle/OwTitle";
import CommissionTierSidebar from "../Commissions/CommissionSidebar/CommissionTierSidebar";
import RebateGroupSidebar from "./RebateGroupSidebar/RebateGroupSidebar";
import * as _ from "lodash-es";
import { Socket } from "socket.io-client";

type Props = {
    supplierModel: ISupplierModel;
    userModel: IUserUI;
    setActivityIndicator?: (activityIndicator: boolean) => void;
    socket: Socket;
    notifyFn: (data: IErrorDTO | null, _notification?: any, isFormatted?: boolean) => void;
    setSidebarComponent: (component: any) => void;
    toggleSidebar: (shouldBeVisible?: boolean) => void;
};

type State = {
    breadcrumbs: IBreadcrumbs[];
    resultsLoaded: boolean;
    rebateGroups: IRebate_GroupUI[];
};

class Rebates extends Component<Props, State> {
    readonly state: State = {
        breadcrumbs: [
            { title: "Dashboard", url: "/dashboard" },
            { title: "Rebates", url: "/business/rebates" },
        ],
        resultsLoaded: false,
        rebateGroups: [],
    };

    componentDidMount(): void {
        this.props.socket.on("onGetRebateGroups", this.onGetRebateGroups);

        this.getRebateGroups();
    }

    componentWillUnmount(): void {
        this.props.socket.removeListener("onGetRebateGroups", this.onGetRebateGroups);
    }

    getRebateGroups = () => {
        this.setState(
            {
                resultsLoaded: false,
            },
            () => {
                const payload: IGetRebateGroupsDTO = {
                    userGuid: this.props.userModel.guid,
                    userToken: this.props.userModel.token,
                    supplierGuid: this.props.supplierModel.guid,
                };

                this.props.socket.emit("getRebateGroups", payload);
            }
        );
    };

    onGetRebateGroups = (data: IOnGetRebateGroupsDTO) => {
        const rebateGroups: IRebate_GroupUI[] = data.rebateGroups.map((group, index) => {
            const newGroup: IRebate_GroupUI = {
                ...group,
                isOpen: index === 0,
            };

            return newGroup;
        });

        this.setState({
            rebateGroups: rebateGroups,
            resultsLoaded: true,
        });
    };

    getRebateGroupSidebar = (rebateGroup?: IRebate_GroupUI) => {
        return (
            <RebateGroupSidebar
                userModel={this.props.userModel}
                socket={this.props.socket}
                supplierModel={this.props.supplierModel}
                toggleSidebar={this.toggleSidebar}
                rebateGroup={rebateGroup}
                notifyFn={this.props.notifyFn}
            />
        );
    };

    toggleSidebar = (shouldBeVisible?: boolean, refreshData?: boolean) => {
        if (refreshData) {
            this.getRebateGroups();
        }

        this.props.toggleSidebar(shouldBeVisible);
    };

    viewRebateGroupSidebar = (rebateGroup?: IRebate_GroupUI) => {
        const rebateGroupSidebar = this.getRebateGroupSidebar(rebateGroup);
        this.props.setSidebarComponent(rebateGroupSidebar);
        this.props.toggleSidebar();
    };

    toggleRebate = (index: number) => {
        const rebateGroups = this.state.rebateGroups;

        if (!_.isNil(index)) {
            rebateGroups[index].isOpen = !rebateGroups[index].isOpen;
        }

        this.setState({
            rebateGroups,
        });
    };

    render() {
        let rebates: any = this.state.rebateGroups.map((rebateGroup: IRebate_GroupUI, rebateGroupIndex: number) => {
            const rebates = (rebateGroup.Rebates || []).map((rebate: IRebate, index: number) => {
                let nextElement = <React.Fragment> - {rebate.max_amount}</React.Fragment>;

                if (!rebate.max_amount) {
                    nextElement = <React.Fragment>+</React.Fragment>;
                }

                return (
                    <tr key={rebate.guid}>
                        <td>{rebate.percent} %</td>
                        <td className={"text-end"}>
                            {rebate.min_amount}
                            {nextElement}
                        </td>
                    </tr>
                );
            });

            return (
                <div key={rebateGroup.id}>
                    <div>
                        <ChevronToggle
                            className={"me-4"}
                            isVisible={rebateGroup.isOpen}
                            toggleFn={() => {
                                this.toggleRebate(rebateGroupIndex);
                            }}
                        />
                        <i
                            className={"fad fa-pencil text-primary me-2 pointer"}
                            onClick={() => {
                                this.viewRebateGroupSidebar(rebateGroup);
                            }}
                        />
                        <OwTitle className={"d-inline-flex me-2"} title={rebateGroup.name} tag={"h4"} disableTranslation={true} />
                    </div>
                    {rebateGroup.isOpen ? (
                        <div className={"d-flex "}>
                            <div className={"d-inline-flex"}>
                                <table className={"table table-dark table-responsive"}>
                                    <tr>
                                        <td className={"w-6r"}>
                                            <OwLabel title={"percent"} isBold={true} />
                                        </td>
                                        <td className={"w-15r text-end"}>
                                            <OwLabel title={"amount"} isBold={true} />
                                        </td>
                                    </tr>
                                    {rebates}
                                </table>
                            </div>
                        </div>
                    ) : null}
                </div>
            );
        });

        const resultsLoaded = this.state.resultsLoaded;

        if (resultsLoaded) {
            if (!this.state.rebateGroups.length) {
                rebates = <NoResults />;
            }
        } else {
            rebates = <LoadingResults />;
        }

        return (
            <div className="Rebates">
                {/*<Breadcrumbs navItems={this.state.breadcrumbs} />*/}

                <div className="row">
                    <div className={"mt-3 col-12 d-flex align-items-center"}>
                        <OwTitle className={"d-inline-flex me-3"} title={"rebates"} leftIconName={"fad fa-money-check-alt"} />
                        <OwButton
                            fn={() => {
                                this.viewRebateGroupSidebar();
                            }}
                            leftIconClass={"far fa-plus"}
                            title={"create"}
                            className={"btn-warning"}
                        />
                    </div>
                </div>
                <div className={"row"}>
                    <div className={"col-12 "}>{rebates}</div>
                </div>
            </div>
        );
    }
}

export default Rebates;
